<template>
    <div>
        <div style="font-weight: bold; font-size: 16pt;">Welcome to Dalounny Closet</div>
        <div style="color: #f06292; font-weight: bold;">Online Shopping Coming Soon</div>
        <div>
            <div v-if="products.length > 0" class="product-row">
                <div v-for="(product, index) in products" :key="index" class="product-column">
                    <div class="product-box">
                        <div class="code">{{ product.code }}</div>
                        <img v-if="product.image" :src="product.image" alt="">
                        <img v-if="!product.image" src="@/assets/images/thumbnail.png" alt="">
                        <div>
                            <div class="name">{{ product.name }}</div>
                            <div class="price">
                                <strong style="color: #e74c7f;">{{ product.price | formatMoney }}</strong> ກີບ
                            </div>
                        </div>
                        <div style="padding: 5px 40px;">
                            <b-field>
                                <b-numberinput v-model="card.qty"
                                               type="is-danger"
                                               size="is-small"
                                               min="1"
                                               :max="product.qty"
                                               :editable="false"
                                               controls-position="compact"
                                               controls-rounded></b-numberinput>
                            </b-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {productsCollection} from "../firebase";

    export default {
        name: "HomePage",
        data() {
            return {
                products: [],
                card: {
                    qty: 1
                }
            }
        },
        firestore() {
            return {
                products: productsCollection.where('deleted', '==', false).where('instock', '==', true).orderBy('created', 'desc'),
            }
        },
    }
</script>

<style scoped lang="scss">
    .product-row {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        margin-top: 20px;
    }

    .product-column {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: calc(100% / 2);
        /*padding-right: 20px;*/
        /*padding-top: 10px;*/
        /*margin: 5px;*/
        padding-bottom: 20px;
    }

    .product-box {
        position: relative;
        width: auto;
        height: 300px;
        background-color: #fff;
        box-shadow: 0 5px 10px #efefef;
        border-radius: 5px;
        margin: 0 5px;
        text-align: center;

        img {
            height: 200px;
        }

        .code {
            position: absolute;
            background-color: rgba(120, 144, 156, 0.8);
            color: #fff;
            padding: 2px 10px;
        }

        .name {
            font-size: 11pt;
        }

        .price {

        }
    }
</style>